module.exports = __webpack_public_path__ + "static/media/strengthbannernewmobile2.42b1ef05.png";